// react
import React, { Component } from 'react'
import { Link } from 'react-router-dom'

// components
import Header from '_components/header/index.jsx'

class Integrations extends Component {
  constructor(props) {
    super(props)
  }

  render() {
    return (
      <div id="integrations-page">
        <Header title="Integrations" />
        <Link to={'/integrations/liveramp'}>LiveRamp</Link>
      </div>
    )
  }
}

// export
export default Integrations
